module.exports = "../../../../platform/assets/pageMainIcon/industry_yewuchulilei4.svg";